import React, { useState } from "react";
import { Box, Card, Typography, CardContent, Grid, makeStyles, Theme } from "@material-ui/core";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import { UnauthorizedRoute } from "../unauthorized.routes";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
    //lineHeight: "28px",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

interface Props {}

export function Unauthorized({}: Props): React.ReactElement {
  const classes = useStyles();
  const [moduleName, setmoduleName] = useState<any>(UnauthorizedRoute.title);
  const [pageHeading, setpageHeading] = useState<any>(UnauthorizedRoute.title);

  const { height } = UseWindowDimensions();
  let wHeight = 0;
  let gridMaxHeight = 0;
  let dppr = 10;
  wHeight = height - 132;
  gridMaxHeight = height - 200;
  if (height > 700 && height < 900) {
    dppr = 15;
  } else if (height > 900) {
    dppr = 25;
  } else {
    dppr = 10;
  }

  return (
    <>
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain} style={{ height: wHeight }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid md={12}>
              <Box marginTop={20} textAlign={"center"}>
                <Typography className={classes.pageHeading}>
                  No user role assigned, please contact administrator
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
